<template>
  <div class="container">
    <el-row>
      <el-col :span="2">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>
      <el-col :span="22">
        <table>
          <tr>
            <td>仪器名称</td>
            <td>{{ form.yqmc }}</td>
            <td>仪器编号</td>
            <td>{{ form.yqbh }}</td>
            <td>校准有效期</td>
            <td>{{ form.jzyxq }}</td>
          </tr>
          <tr>
            <td>序号</td>
            <td>被检测设备位置</td>
            <td>被检测设备名称</td>
            <td>实测距离（m）</td>
            <td colspan="2">检测结果</td>
          </tr>
          <template v-for="(item,i) in tableData">
            <tr :key="i">
              <td>{{ item.id }}</td>
              <td>{{ item.bjcsbwz }}</td>
              <td>{{ item.bjcsbmc }}</td>
              <td>{{ item.scjl }}</td>
              <td colspan="2">{{ item.jcjg }}</td>
            </tr>
          </template>
        </table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      project_id: '',
      site_id: '',
      site_type: '',
      rr_type: 'report',
      tableData: [],
      form: {
        yqmc: '',
        yqbh: '',
        jzyxq: ''
      },
    }
  },
  methods: {
    async getForm() {
      try {
        this.loading = true;
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
        }
        this.form = await this.$Api.get("record_cma_jl1", {params: params});
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("record_cma_jl", {params: params});
        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.getForm()
    this.getList()
  }
}
</script>
<style scoped>
table {
  width: 100%;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  vertical-align: middle !important;
}
</style>
